import { baseURL } from '@/api/httpAxios'

export const productionURL = 'https://digital.etu.ru'
export const devProductionURL = 'https://dev.digital.etu.ru'

export const supportEmail = 'dss@etu.ru'
export const orgEmail = 'dpo_leti@mail.ru'
export const depEmail = 'digitaldep@etu.ru'
export const wikiURL = 'https://digital.etu.ru/doku.php?id=navigation:ino'

export const wikiPage = (name: string) => wikiURL + '?id=' + name

export const lkETUName = 'LK ID'

export const isDev = process.env.NODE_ENV !== 'production'
export const isProduction = process.env.NODE_ENV === 'production'

export const authBase = `${baseURL}/auth/`
export const authDevBase = `${baseURL}/auth/dev`
export const etuIdAuthBase = `${baseURL}/auth/etuid`

export const clientBase = isProduction ? '/dpo' : ''
export const clientBaseWithSlash = clientBase + '/'
